import Client from "./Clients/AxiosClient";
const resource = "/api/v1/user/order";

export default {
  checkout(payload) {
    return Client.post(`${resource}/checkout`, payload);
  },
  checkoutSingle(payload) {
    return Client.post(`${resource}/checkout/duitku/single`, payload);
  },
  cancel(id) {
    return Client.put(`${resource}/cancel/${id}`, id);
  },
  getHistories(page, size, sort, search) {
    return Client.get(
      `${resource}/order-histories?page=${page}&size=${size}&sort=${sort}&search=${search}`
    );
  },
  getHistory(id) {
    return Client.get(`${resource}/order-histories/${id}`);
  },
};
